import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TipoLogradouro } from '@tivic-team/manager-ts/dist/grl';
import { TipoLogradouroService } from 'app/services/grl/tipo-logradouro.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'dropdown-tipo-logradouro',
  templateUrl: './dropdown-tipo-logradouro.component.html',
  styleUrls: ['./dropdown-tipo-logradouro.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownTipoLogradouroComponent implements OnInit {

  logradouros: TipoLogradouro[];
  formGroup: FormGroup;

  constructor(
    public _tipoLogradouroService:TipoLogradouroService,
    private _dialogFactory: DialogFactory
  ) { }

  ngOnInit() { }

  ngAfterViewInit(){
    this.load();
  }

  async load(){
    try{
      this.logradouros = await this._tipoLogradouroService.getAll();
    }
    catch(responseError){
      this._dialogFactory.snack('Carregamento de dados falhou.', 'OK', DialogFactory.SNACK_WARNING);
    }
  }

  selecionarTipologradouro(cdTipoLogradouro:number){
    this.formGroup.get('cdTipoLogradouro').setValue(cdTipoLogradouro);
  }

}
